import * as d3 from "d3";
import dataD3ComponentMixin from "./data-d3-component-mixin.js";

export default {
  mixins: [dataD3ComponentMixin],
  data() {
    return {
      spinner: null
    };
  },
  mounted() {
    // this.arcPrepare();
  },
  methods: {
    degToRad(degrees) {
      return (degrees * Math.PI) / 180;
    },

    arcPrepare() {
      const animationTime = 1200;
      const loaderRadius = 40;
      const loaderColor = "#068bea";
      function arcTween(newAngle, angle) {
        return function(d) {
          var interpolate = d3.interpolate(d[angle], newAngle);
          return function(t) {
            d[angle] = interpolate(t);
            return arc(d);
          };
        };
      }

      var arc = d3
        .arc()
        .innerRadius(0)
        .outerRadius(loaderRadius);

      var svg = d3.selectAll(".spinner"),
        width = +svg.attr("width"),
        height = +svg.attr("height"),
        g = svg
          .append("g")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      var loader = g
        .append("path")
        .datum({ endAngle: 180, startAngle: 0 })
        .style("fill", loaderColor)
        .attr("d", arc);
      svg
        .append("text")
        //.attr("class", "text-per-mouse")
        //.style("font-size", "6px")
        //.style("stroke", "gray")
        .attr("x", width * 0.3)
        .attr("y", height * 0.75)
        .style("fill", "#068bea")
        .style("stroke-width", "0.5px")
        .text("data are being collected ...");

      this.spinner = d3.interval(() => {
        loader.datum({ endAngle: 0, startAngle: 0 });

        loader
          .transition()
          .duration(animationTime)
          .attrTween("d", arcTween(this.degToRad(360), "endAngle"));

        loader
          .transition()
          .delay(animationTime)
          .duration(animationTime)
          .attrTween("d", arcTween(this.degToRad(360), "startAngle"));
      }, animationTime * 2);
    },
    arcStop() {
      this.spinner.stop();
      var svg = d3.selectAll(".spinner");
      svg.style = "display:none";
      svg.selectAll("text").remove();
    }
  }
};
